import createStore from 'zustand'
import persist from '../utils/persist'

export const useCenterStore = createStore(
  persist(
    {
      key: 'currentCalibrationCenter'
    },
    (set) => ({
      ccId: 0,
      centerDetail: {},
      userList: [],
      // Tracks which ccId the cached userList was last fetched for. PageLayout uses
      // this to dedupe the fetch across page navigations and trigger a refetch when
      // the active center changes.
      userListCcId: null,
      accessibleCcIds: [],
      isCenterAdmin: false,
      centerSummaries: {},
      // CAR-3630: true once the full calibration-center list has loaded this session
      // (warm session cache or a successful getCalibrationCenterList). The navbar
      // location switcher stays disabled until then so users never interact with a
      // half-populated dropdown. Managed by PageLayout's bootstrap.
      centerListLoaded: false,
      reset: () =>
        set(() => ({
          ccId: 0,
          centerDetail: {},
          userList: [],
          userListCcId: null,
          accessibleCcIds: [],
          isCenterAdmin: false,
          centerSummaries: {},
          centerListLoaded: false
        })),
      setCenterDetail: (newCenter) => {
        set((state) => ({
          centerDetail: { ...newCenter },
          ccId: newCenter.id,
          centerSummaries:
            newCenter?.id != null
              ? {
                  ...state.centerSummaries,
                  [newCenter.id]: { id: newCenter.id, name: newCenter.name, is_active: newCenter.is_active ?? newCenter.active }
                }
              : state.centerSummaries
        }))
      },
      setCcId: (newId) => {
        set(() => ({
          ccId: newId
        }))
      },
      setUserList: (newUsers) => {
        set(() => ({
          userList: newUsers
        }))
      },
      setUserListCcId: (ccid) => {
        set(() => ({
          userListCcId: ccid ?? null
        }))
      },
      setAccessibleCcIds: (ids) => {
        set(() => ({
          accessibleCcIds: Array.from(new Set((ids || []).filter((id) => id != null)))
        }))
      },
      setIsCenterAdmin: (isAdmin) => {
        set(() => ({
          isCenterAdmin: !!isAdmin
        }))
      },
      setCenterListLoaded: (loaded) => {
        set(() => ({
          centerListLoaded: !!loaded
        }))
      },
      upsertCenterSummaries: (centers) => {
        const list = Array.isArray(centers) ? centers : [centers]
        set((state) => {
          const next = { ...state.centerSummaries }
          list.forEach((c) => {
            if (c?.id != null) next[c.id] = { id: c.id, name: c.name, is_active: c.is_active ?? c.active }
          })
          return { centerSummaries: next }
        })
      }
    })
  )
)
